<!-- @format -->

<div class="loading-screen-container">
  <div class="loading-screen-content">
    <div class="spinner-border"></div>
    @if (descriptionKey1) {
      <p>{{ descriptionKey1 | translate }}</p>
    }
    @if (descriptionKey2) {
      <p>{{ descriptionKey2 | translate }}</p>
    }
  </div>
</div>
